// Module
var code = "<div class=\"block height-100\"> <h2>Manage Currencies</h2> <div id=\"currencyGrid\" class=\"height-100 padding-bottom-30\"></div> </div> ";
// Exports
export default code;